import PropTypes from 'prop-types';

const validationTypes = ['error', 'warning', ''];

export default PropTypes.oneOf(validationTypes);
